import Icon1 from "../../icons/Icon";
import {
  getArrayDocDataByID,
  getArrayDocDataByRef,
} from "../../models/DataFunctions";

export const isCarnetAdmin = (orgData, carnetData) => {
  if (orgData && carnetData) {
    if (orgData.id === carnetData.master_id) {
      return true;
    }
  }
  return false;
};

export const isCarnetClient = (orgData, carnetData) => {
  if (orgData && carnetData) {
    if (orgData.id === carnetData.client_id) {
      return true;
    }
  }
  return false;
};

export const isCarnetAdminOrClient = (orgData, carnetData) => {
  if (orgData && carnetData) {
    if (isCarnetAdmin(orgData, carnetData)) {
      return true;
    }
    if (isCarnetClient(orgData, carnetData)) {
      return true;
    }
  }
  return false;
};

export const CarnetTypeIcon = ({ type }) => {
  switch (type) {
    case "infiltro":
      return <Icon1 icon_name="hexagone-infiltro" size={20} />;
    case "audit":
      return <Icon1 icon_name="hexagone-audit" size={20} />;
    case "thermo":
      return <Icon1 icon_name="hexagone-thermo" size={20} />;
    case "basic":
      return <Icon1 icon_name="hexagone-basic" size={20} />;
  }
};

export const getCommunWorkspace = async (orgData, masterData) => {
  let all_workspaces = await getArrayDocDataByID(
    "workspace",
    orgData.workspaces_id || []
  );
  let commun_workspaces = all_workspaces.find((w) => {
    return w.master_id === masterData.id;
  });
  return commun_workspaces;
};

export const getCarnetTypeName = (type) => {
  switch (type) {
    case "infiltro":
      return "INFILTRO";
    case "audit":
      return "AUDIT";
    case "thermo":
      return "BE";
    case "basic":
      return "BASIQUE";
    default:
      return "";
  }
};
